(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-navigation-mobile-bottom"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      if (!document.querySelector('.hdr-mobile-bottom.mnt-mobile-nav')) return;
      if (window.mntMobileNavRefresh) {
        window.mntMobileNavRefresh();
        return;
      }

      // Set to false to keep the compact bar visible while scrolling.
      const autoHideOnScroll = true;
      const body = document.body;
      const mobile = window.matchMedia('(max-width: 1024px)');
      const selector = '.hdr-mobile-bottom.mnt-mobile-nav';
      let scrollHidden = false;
      let keyboardNavigation = false;
      let lastY = Math.max(0, window.scrollY);
      let direction = 0;
      let distance = 0;
      let framePending = false;

      const isTyping = () => {
        const element = document.activeElement;
        if (!element || element.disabled || element.readOnly) return false;
        if (element.isContentEditable || element.tagName === 'TEXTAREA') return true;
        return element.tagName === 'INPUT' && ![
          'button', 'checkbox', 'color', 'file', 'hidden', 'image',
          'radio', 'range', 'reset', 'submit'
        ].includes(element.type);
      };

      const sync = () => {
        const bar = document.querySelector(selector);
        if (!bar) return;
        const nativeKeyboard = body.classList.contains('safari') && body.classList.contains('has-keyboard-open');
        const typing = mobile.matches && (isTyping() || nativeKeyboard);
        const concealed = mobile.matches && autoHideOnScroll && scrollHidden &&
          !keyboardNavigation && !bar.contains(document.activeElement) && !window.Shopify?.designMode;
        bar.classList.toggle('mnt-mobile-nav--typing', typing);
        bar.classList.toggle('mnt-mobile-nav--concealed', concealed);
        bar.toggleAttribute('inert', typing || concealed);
        const visible = mobile.matches && !typing && !concealed;

        if (body.classList.contains('has-mobile-bottom') !== visible) {
          body.classList.toggle('has-mobile-bottom', visible);
        }
      };

      const reveal = () => {
        scrollHidden = false;
        distance = 0;
        direction = 0;
        lastY = Math.max(0, window.scrollY);
        sync();
      };

      const updateScroll = () => {
        framePending = false;
        const y = Math.max(0, window.scrollY);
        const delta = y - lastY;
        lastY = y;
        const bar = document.querySelector(selector);
        if (!bar) return;
        if (!mobile.matches || !autoHideOnScroll || isTyping() || keyboardNavigation || window.Shopify?.designMode ||
            bar.contains(document.activeElement) || y < 120) {
          scrollHidden = false;
          distance = 0;
          direction = 0;
          sync();
          return;
        }
        if (Math.abs(delta) < 1) return;
        const nextDirection = Math.sign(delta);
        if (direction !== nextDirection) distance = 0;
        direction = nextDirection;
        distance += Math.abs(delta);
        if (distance >= (direction > 0 ? 32 : 10)) {
          scrollHidden = direction > 0;
          distance = 0;
          sync();
        }
      };

      window.addEventListener('scroll', () => {
        if (framePending) return;
        framePending = true;
        window.requestAnimationFrame(updateScroll);
      }, { passive: true });
      document.addEventListener('focusin', reveal);
      document.addEventListener('focusout', () => window.requestAnimationFrame(reveal));
      document.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        keyboardNavigation = true;
        reveal();
      });
      document.addEventListener('pointerdown', () => { keyboardNavigation = false; }, { passive: true });

      // Observe only native visibility flags; never change main-header scroll classes.
      new MutationObserver(sync).observe(body, {
        attributes: true,
        attributeFilter: ['class']
      });

      mobile.addEventListener('change', reveal);
      document.addEventListener('shopify:section:load', reveal);
      window.mntMobileNavRefresh = reveal;
      sync();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
